<template>
    <div v-if="loaded">
        <div v-for="(item, index) in contentItems">
            <toggle-content
                :label="item.course_location_place"
                name="location"
                :id="index">
                <div class="course-location">
                    <course-location-item v-for="(day, key) in item.course_location_dates" :data="day" :key="key" />
                </div>
            </toggle-content>
        </div>
    </div>
</template>

<script>
import ToggleContent from './ToggleContent.vue';
import CourseLocationItem from './CourseLocationItem.vue';
import Icon from './Icon.vue';

export default {
    name: 'CourseLocations',
    data() {
        return {
            loaded: false,
            contentItems: []
        };
    },
    props: ['items'],
    mounted: function() {
        this.contentItems = JSON.parse(this.items);
        this.contentItems.sort( this.compare );
        this.loaded = true;
    },
    methods: {
        compare(a, b) {
            if ( a.course_location_place < b.course_location_place ){
                return -1;
            }
            if ( a.course_location_place > b.course_location_place ){
                return 1;
            }
            return 0;
        }
    },
    components: {
        ToggleContent,
        Icon,
        CourseLocationItem
    },
};
</script>